import React from 'react'
import { TabPane } from 'rc-tabs'
import PropTypes from 'prop-types'
import StyledTab from './styled/index'

const OwTabs = function ({
  className,
  tabBarStyle,
  // tabPanes,
  defaultActiveKey,
  activeKey,
  tabBarExtraContent,
  direction,
  tabBarPosition,
  tabBarGutter,
  animated,
  destroyInactiveTabPane,
  // renderTabBar,
  moreIcon,
  onTabScroll,
  onTabClick,
  onChange,
  children,
}) {
  return (
    <StyledTab
      style={tabBarStyle}
      className={className}
      // className={StyledTab}
      tabBarExtraContent={tabBarExtraContent}
      defaultActiveKey={defaultActiveKey}
      moreIcon={moreIcon}
      direction={direction}
      tabPosition={tabBarPosition}
      tabBarGutter={tabBarGutter}
      animated={animated}
      destroyInactiveTabPane={destroyInactiveTabPane}
      activeKey={activeKey}
      onTabScroll={onTabScroll}
      onTabClick={onTabClick}
      onChange={onChange}
      // renderTabBar={renderTabBar}
      // tabpanes={tabPanes}
    >
      {children}
    </StyledTab>
  )
}

OwTabs.TabPane = TabPane

// 参数类型
OwTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabBarStyle: PropTypes.object,
  animated: PropTypes.string,
  tabBarGutter: PropTypes.number,
  tabBarPosition: PropTypes.string,
  tabBarExtraContent: PropTypes.string,
  defaultActiveKey: PropTypes.string,
  activeKey: PropTypes.string,
  moreIcon: PropTypes.string,
  direction: PropTypes.string,
  // renderTabBar: PropTypes.shape,
  destroyInactiveTabPane: PropTypes.bool,
  // tabPanes: PropTypes.arrayOf(PropTypes.shape(TabPane)),
  onTabScroll: PropTypes.func,
  onTabClick: PropTypes.func,
  onChange: PropTypes.func,
}

OwTabs.defaultProps = {
  tabBarStyle: {},
  animated: undefined,
  tabBarGutter: undefined,
  tabBarPosition: undefined,
  tabBarExtraContent: undefined,
  defaultActiveKey: undefined,
  activeKey: undefined,
  moreIcon: undefined,
  direction: undefined,
  // renderTabBar: undefined,
  destroyInactiveTabPane: false,
  // tabPanes: [],
  onTabScroll: null,
  onTabClick: null,
  onChange: null,
}
export default OwTabs
